import { registerRoot } from "remotion";
import { RemotionRoot } from "@/components/editor/remotion/root";

registerRoot(RemotionRoot);
